import { Box } from "@mui/material";
import { ChartLoadingState } from "src/components/common/charts/highstock/highstock-line-chart/components/chart-loading-state";
import { LINE_CHART_HEIGHT } from "src/components/common/charts/highstock/highstock-line-chart/constants";

const TIME_RANGE_CONTROLS_HEIGHT = { xs: "40px", sm: "32px" };

export const DetailBenchmarkLoadingState = () => (
    <>
        <Box sx={{ height: TIME_RANGE_CONTROLS_HEIGHT, mb: 4 }} />
        <Box sx={{ position: "relative", height: LINE_CHART_HEIGHT }}>
            <ChartLoadingState />
        </Box>
    </>
);
